import React from 'react';
import styled from 'styled-components';
import { Typography } from 'antd';
import { TitleProps as AntdTitleProps } from 'antd/lib/typography/Title';
import { isString, kebabCase } from 'lodash';

const { Title: AntdTitle } = Typography;

export interface TitleProps extends AntdTitleProps {
  textAlign?: 'left' | 'center' | 'right';
  hideMargin?: boolean;
  inline?: boolean;
  dataCy?: string;
}

const StyledTitle = styled(AntdTitle)<{
  $textAlign: TitleProps['textAlign'];
  $hideMargin: TitleProps['hideMargin'];
  $inline: TitleProps['inline'];
}>`
  && {
    text-align: ${({ $textAlign }) => $textAlign};
    ${({ $hideMargin }) => $hideMargin && `margin-bottom: 0`};
    ${({ $inline }) => $inline && `display: inline`};
  }
`;

export const Title: React.FC<TitleProps> = ({
  textAlign = 'left',
  hideMargin,
  inline,
  ...props
}) => {
  const dataCy =
    (props as any)['data-cy'] ||
    props.dataCy ||
    // !do not rely on this to add data-cy
    `${kebabCase(React.Children.toArray(props.children).find(isString))}-title`;

  return (
    <StyledTitle
      $textAlign={textAlign}
      $hideMargin={hideMargin}
      $inline={inline}
      data-cy={dataCy}
      {...props}
    />
  );
};

export default styled(Title)``;
